module.exports = __webpack_public_path__ + "img/login-logo.616b2e0.svg";